import _ from "lodash";
/**--external-- */
import React from "react";
import classNames from "classnames";
import { Badge, Button, IconButton } from "@toddle-edu/ds-web";
import { AddCircleOutlined, DeleteOutlined } from "@toddle-edu/ds-icons";

/**--internal-- */
import {FormTextAreaInput} from "UIComponents/TextAreaInput";
import {FormSelectDropdown} from "UIComponents/SelectDropdown";
import UIBaseComponent from "UIComponents/UIBaseComponent";
import I18nHOC from "UIComponents/I18nHOC";
import { generateRandomId } from "Utils";

/**--relative-- */
import classes from "./InputNumberListWithTag.scss";
import {
  textAreaStyle,
  textAreaInputContainerStyle,
} from "./InputNumberListWithTagStyles";

class InputNumberListWithTag extends UIBaseComponent {
  constructor(props) {
    super(props);

    this.listRefs = [];

    if (props.mode === "edit" && _.isEmpty(props.value)) {
      this.addField();
    }
  }

  componentDidUpdate = prevProps => {
    const { value: oldValue } = prevProps;
    const { value } = this.props;
    const oldValueLength = _.size(oldValue);
    const newValueLength = _.size(value);
    if (newValueLength > oldValueLength) {
      this.listRefs[newValueLength - 1]?.scrollIntoView?.({
        behavior: "smooth",
      });
    }
  };

  addField = () => {
    const { value, tagOptions } = this.props;

    const id = generateRandomId();
    const tag = _.get(_.first(tagOptions), "value", null);
    const updatedValues = [...(value || []), { id, tag }];

    this.updateValue(updatedValues);
  };

  editField = ({ payload }) => {
    const { value } = this.props;
    const updatedValue = _.map(value, ({ id, ...rest }) => {
      if (id === payload.id) {
        return { id, ...rest, ...payload };
      }
      return { id, ...rest };
    });

    this.updateValue(updatedValue);
  };

  deleteField = ({ id }) => {
    const { value } = this.props;
    const updatedValue = _.filter(value, ({ id: currentId }) => {
      return id !== currentId;
    });

    this.updateValue(updatedValue);
  };

  renderView = () => {
    const { value: values } = this.props;
    const optionClasses = classNames("text-body-2", classes.option);

    const tagClasses = classNames("text-body-2", classes.tag);

    return (
      <ul className={classes.viewContainer}>
        {_.map(values, ({ value, tag, id }) => {
          return (
            <li key={id} className={optionClasses}>
              {value} {tag && <div className={tagClasses}>{` (${tag})`}</div>}
            </li>
          );
        })}
      </ul>
    );
  };

  renderEdit = () => {
    const { value, tagOptions, t, subHeaderLabels } = this.props;

    const headerLabelClasses = classNames("heading-6", classes.headerLabel);

    const isAddButtonDisabled = _.some(value, ({ value }) => _.isEmpty(value));

    return (
      <div className={classes.container}>
        <div className={classes.headerContainer}>
          {_.map(subHeaderLabels, label => {
            return (
              <h6 className={headerLabelClasses} key={label}>
                {label}
              </h6>
            );
          })}
        </div>
        <div className={classes.scrollContainer}>
          <div className={classes.listContainer}>
            {_.map(value, ({ id, value, tag }, index) => {
              const onTextAreaChange = value => {
                this.editField({ payload: { id, value } });
              };

              const onDropdownChange = tag => {
                this.editField({ payload: { id, tag } });
              };

              const onDeleteClick = () => {
                this.deleteField({ id });
              };

              return (
                <div
                  className={classes.fieldWithDeleteContainer}
                  key={id}
                  ref={node => {
                    this.listRefs[index] = node;
                  }}
                >
                  <div className={classes.fieldContainer}>
                    <Badge
                      variant="filter"
                      size="large"
                      type="numeric"
                      value={index + 1}
                    />
                    <FormTextAreaInput
                      value={value}
                      containerStyle={textAreaInputContainerStyle}
                      minRows={1}
                      textAreaStyle={textAreaStyle}
                      updateInputField={onTextAreaChange}
                    />
                  </div>
                  <FormSelectDropdown
                    size="medium"
                    updateInputField={onDropdownChange}
                    options={tagOptions}
                    value={tag}
                    placeholder={t("common:select")}
                  />
                  <IconButton
                    icon={<DeleteOutlined />}
                    variant="plain"
                    size="small"
                    className={classes.deleteIconContainer}
                    onClick={onDeleteClick}
                  />
                </div>
              );
            })}
            <Button
              size="medium"
              variant="inline-progressive"
              icon={<AddCircleOutlined />}
              onClick={this.addField}
              disabled={isAddButtonDisabled}
            >
              {t("common:add_with_label", { label: t("common:another") })}
            </Button>
          </div>
        </div>
      </div>
    );
  };
}

export default I18nHOC({ resources: ["common"] })(InputNumberListWithTag);

InputNumberListWithTag.displayName = "InputNumberListWithTag";
